import { Directive, ElementRef, Input, OnInit, Optional } from '@angular/core';
import { Dialog } from '../dialog.service';
import { DialogRef } from '../helpers/dialog-ref';
import { getClosestDialog } from '../helpers/dialog-ref';

let dialogElementUid = 0;

/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
@Directive({
	selector: '[flx-dialog-title], [flxDialogTitle]',
	exportAs: 'flxDialogTitle',
	host: {
		class: 'flx-dialog-title',
		'[id]': 'id'
	}
})
export class DialogTitleDirective implements OnInit {
	@Input() id = `flx-dialog-title-${dialogElementUid++}`;

	constructor(@Optional() private _dialogRef: DialogRef<any>, private _elementRef: ElementRef, private _dialog: Dialog) {}

	ngOnInit() {
		if (!this._dialogRef) {
			this._dialogRef = getClosestDialog(this._elementRef, this._dialog.openDialogs)!;
		}

		if (this._dialogRef) {
			Promise.resolve().then(() => {
				const container = this._dialogRef._containerInstance;

				if (container && !container._ariaLabelledBy) {
					container._ariaLabelledBy = this.id;
				}
			});
		}
	}
}
